import { module } from 'modujs';
import { DEFAULT_VUE_FORM, DEFAULT_VUE_DATA, isPostalCodeValid } from '../utils/form'

const { required, email, requiredIf, sameAs } = window.validators;

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {

        // Init vue
        this.initVue();
    }

    destroy() {
        super.destroy();
        this.app?.$destroy?.()
    }

    /////////////////////////
    // Vue Instance
    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Import vuelidate
        Vue.use(window.vuelidate.default);

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            ...DEFAULT_VUE_FORM,

            el: this.el,
            mixins: [ {
                data: DEFAULT_VUE_DATA(this.el),
            } ],
            data() {
                return {
                    formData: {
                        location: '',
                        locationSpecify: '',
                        date: '',
                        orderNumber: '',
                        gameName: '',
                        message: '',
                        firstname: '',
                        lastname: '',
                        email: '',
                        address: '',
                        city: '',
                        postalCode: '',
                        country: '',
                        phone: '',
                        terms: '',
                        newsletter: ''
                    }
                }
            },

            validations: {
                ...DEFAULT_VUE_FORM.validations.formData,

                formData: {
                    location: {
                        required
                    },
                    locationSpecify: {
                        required: requiredIf(function () {
                            return this.formData.location == 'other';
                        })
                    },
                    date: {
                        required
                    },
                    orderNumber: {
                        required
                    },
                    gameName: {
                        required
                    },
                    message: {
                        required
                    },
                    firstname: {
                        required
                    },
                    lastname: {
                        required
                    },
                    email: {
                        required,
                        email
                    },
                    address: {

                    },
                    city: {

                    },
                    postalCode: {
                        isPostalCodeValid
                    },
                    country: {

                    },
                    phone: {

                    },
                    terms: {
                        sameAs: sameAs( () => true )
                    },
                    newsletter: {}
                }
            },

            created() {
                //Important to make scrollTo error working
                this.moduleInstance = moduleInstance
            },

            methods: {
                ...DEFAULT_VUE_FORM.methods,
            }
        });
    }
}
